module.exports = __webpack_public_path__ + "static/media/velora-isotipo-blanco.66b2294d.svg";